import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import { siteThemes, theme, isDefaultTheme, isGlobetrotter } from '../../utils/theming.js';
import { focusOutline } from '../../utils/mixins.js';
import Icon from '../Icon/Icon.js';

var DEFAULT = siteThemes.DEFAULT,
  GLOBETROTTER = siteThemes.GLOBETROTTER;
var borderColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["", ""], function (_ref) {
  var $hasError = _ref.$hasError,
    $isValid = _ref.$isValid;
  if ($hasError) return css(["border-color:var(--color-notif-system-error);"]);
  if ($isValid) return css(["border-color:var(--color-notif-system-success);"]);
  return css(["border-color:var(--color-border-primary);"]);
})), GLOBETROTTER, css(["", ""], function (_ref2) {
  var $hasError = _ref2.$hasError,
    $isValid = _ref2.$isValid;
  if ($hasError) return css(["border-color:var(--color-notif-system-error);"]);
  if ($isValid) return css(["border-color:var(--color-green-500);"]);
  return css(["border-color:var(--color-border-primary);"]);
})));
var border = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["border:1px solid;border-radius:var(--border-radius-300);"])), GLOBETROTTER, css(["border-bottom:1px solid;border-radius:0;"])));
var focusBorder = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["", ""], focusOutline)), GLOBETROTTER, css(["border-color:var(--color-almostblack);border-bottom:2px solid;"])));
var TextArea = styled.textarea.withConfig({
  displayName: "style__TextArea",
  componentId: "sc-dstf8r-0"
})(["", " ", " box-sizing:border-box;display:block;font-family:var(--font-family-body);font-size:1.6rem;outline:none;line-height:1.5;padding:var(--space-300) var(--space-400);width:100%;position:relative;color:var(--color-text-subtle);resize:vertical;&:focus{outline:none;box-shadow:none;", "}"], border, borderColor, focusBorder);
var TextAreaWrapper = styled.div.withConfig({
  displayName: "style__TextAreaWrapper",
  componentId: "sc-dstf8r-1"
})(["position:relative;width:100%;"]);
var ValidationText = styled.span.withConfig({
  displayName: "style__ValidationText",
  componentId: "sc-dstf8r-2"
})(["", " margin-top:var(--space-50);background:var(--color-notif-system-error);width:100%;position:absolute;padding:var(--space-200) var(--space-400);z-index:1;top:calc(100% + var(--space-100));"], isDefaultTheme(css(["color:var(--color-white);border-radius:var(--border-radius-300);"])));
var TextAreaIcon = styled(Icon).withConfig({
  displayName: "style__TextAreaIcon",
  componentId: "sc-dstf8r-3"
})(["color:var(--color-notif-system-success);", " position:absolute;top:var(--space-300);right:var(--space-400);display:flex;justify-content:center;text-align:center;", ""], function (_ref3) {
  var $hasError = _ref3.$hasError;
  return $hasError && css(["color:var(--color-notif-system-error);"]);
}, isGlobetrotter(css(["display:none;"])));

export { TextArea, TextAreaIcon, TextAreaWrapper, ValidationText };
//# sourceMappingURL=style.js.map
